import { Injectable } from '@angular/core';
import { StreakSnapshot } from './client-streak.service';
import { MemoryItem } from './client-memories.service';
import { AskSuggestion } from '@constants/ask-suggestions.constants';

export interface ClientHomeState {
  loaded: boolean;
  religion: string | null;
  userId: string | null;

  banners: any[];
  dailyVerse: any;
  dailyFree: any;
  creditsAvailable: number;
  suggestions: AskSuggestion[];

  streak: StreakSnapshot | null;
  memories: MemoryItem[];

  pendingDeletion: boolean;
  deletionDaysRemaining: number | null;

  currentReligionLabel: string | null;
}

const DEFAULT_STATE: ClientHomeState = {
  loaded: false,
  religion: null,
  userId: null,
  banners: [],
  dailyVerse: null,
  dailyFree: null,
  creditsAvailable: 0,
  suggestions: [],
  streak: null,
  memories: [],
  pendingDeletion: false,
  deletionDaysRemaining: null,
  currentReligionLabel: null,
};

@Injectable({ providedIn: 'root' })
export class ClientHomeStateService {
  private state: ClientHomeState = { ...DEFAULT_STATE };

  snapshot(): ClientHomeState {
    return {
      ...this.state,
      banners: [...this.state.banners],
      suggestions: [...this.state.suggestions],
      memories: [...this.state.memories],
    };
  }

  hydrate(partial: Partial<ClientHomeState>): void {
    this.state = { ...this.state, ...partial };
  }

  markLoaded(religion: string | null, userId: string | null): void {
    this.state = { ...this.state, loaded: true, religion, userId };
  }

  reset(): void {
    this.state = { ...DEFAULT_STATE };
  }

  isStale(currentReligion: string | null, currentUserId: string | null): boolean {
    if (!this.state.loaded) return true;
    if (this.state.userId !== currentUserId) return true;
    return this.state.religion !== currentReligion;
  }
}
